import { render, staticRenderFns } from "./ModalExclusaoServicesParts.vue?vue&type=template&id=63a06638&"
import script from "./ModalExclusaoServicesParts.vue?vue&type=script&lang=js&"
export * from "./ModalExclusaoServicesParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports